<div id="no-compatible" *ngIf="!isCompatible">
  <hb-explorercompatibility></hb-explorercompatibility>
</div>

<div *ngIf="isMaintenanceMode">
  <hb-maintenancemode></hb-maintenancemode>
</div>
<div *ngIf="showTermsAndConditions">
  <hb-termsandconditions
    (onAceptedTerms)="acceptTerms($event)"
    [contractsToAddTerms]="contractsToAddTerms"
  ></hb-termsandconditions>
</div>

<hb-terms-and-conditions-global
  *ngIf="showTradingGlobalTermsAndConditions"
  (acceptTerms)="handleAcceptTradingUsaAgreements()"
></hb-terms-and-conditions-global>

<app-loader
  *ngIf="userHasNoContracts === undefined && !isMaintenanceMode"
></app-loader>

<hb-geolocation
  *ngIf="enableGeolocationOperationsFeatureFlag$ | async"
></hb-geolocation>
<hb-price-alerts *ngIf="openPriceAlerts$ | async"></hb-price-alerts>

<div
  *ngIf="
    userHasNoContracts &&
    isCompatible &&
    !isMaintenanceMode &&
    !showTermsAndConditions &&
    !showTradingGlobalTermsAndConditions
  "
  id="user-hasno-contracts"
>
  <header>
    <div class="logo-container">
      <img alt="GBMHomeBroker" src="images/logo-homebroker.png" />
    </div>
  </header>
  <article>
    <section class="title">
      Sé de los primeros en abrir tu contrato de GBMhomebroker con tan sólo
      $1,000 MXN.
    </section>
    <section class="subtitle">
      GBMhomebroker está revolucionando las inversiones y ahora invertir en el
      mercado nacional e internacional es más fácil. Ve a nuestro sitio y da
      click en el botón “Unirme a la lista” para que muy pronto tengas acceso a
      nuestra nueva plataforma web y aplicaciones móviles.
    </section>

    <section class="buttons">
      <a href="https://www.gbmhomebroker.com">
        <button class="btn-movement active">Ir al sitio</button>
      </a>
    </section>
  </article>
</div>

<hb-not-funded-modal
  *ngIf="showNotFundedModal"
  (closeModal)="showNotFundedModal = false"
>
</hb-not-funded-modal>

<div
  class="main-wrapper"
  [class.main-wrapper--disabled]="isBalanceActionSelected"
  *ngIf="
    userHasNoContracts === false &&
    isCompatible &&
    !isMaintenanceMode &&
    !showTermsAndConditions &&
    !showTradingGlobalTermsAndConditions
  "
>
  <div
    *ngIf="userHasDashboard"
    class="link-to-dashboard link-to-dashboard--animated"
  >
    <a class="link-to-dashboard__right-content" [href]="gbmDashboardUrl">
      <span>IR AL DASHBOARD</span>
      <img alt="Ir a dashboard" src="/images/atm-icn_mini-arrow.svg" />
    </a>
  </div>
  <hb-navigation [hasDashboard]="userHasDashboard"></hb-navigation>

  <section class="main-container">
    <div
      class="main-left-content"
      [ngClass]="{
        'main-left-content--banner':
          isBannerVisible && disabledTradingUsaOperation
      }"
    >
      <!-- Banner Maintenance/Intermitent service -->
      <hb-banner
        *ngIf="
          (bannerMessage && (isServiceInterrupted$ | async)) ||
          disabledTradingUsaOperation
        "
        [message]="bannerMessage"
        [type]="bannerType.maintenanceMode"
      ></hb-banner>

      <!-- Banner Maintenance/Intermitent service -->
      <hb-banner
        *ngIf="
          !((isServiceInterrupted$ | async) || disabledTradingUsaOperation) &&
          customInfoBanner.valid
        "
        [message]="customInfoBanner.message"
        [icon]="customInfoBanner.icon"
      ></hb-banner>

      <router-outlet></router-outlet>
    </div>
    <div
      class="main-right-content"
      [ngClass]="{
        'main-right-content--banner--trading-global':
          isBannerVisible && !disabledTradingUsaOperation
      }"
    >
      <app-balance-actions
        [ngClass]="{
          'balance-actions--banner--trading-global':
            isBannerVisible && !disabledTradingUsaOperation
        }"
        [isGlobalContract]="isGlobalContract"
        [currentContract]="currentContract"
        [isLoremAccount]="isLoremAccount"
        [userHasDashboard]="userHasDashboard"
        (onBalanceActionSelected)="isBalanceActionSelected = $event"
      ></app-balance-actions>
      <!-- TODO: [Angular 7] Fix Tradebar Loading. Check Component for more info -->
      <!-- <ng-template #operationPuppet hbDynamicComponentHost></ng-template> -->
      <hb-trade-bar></hb-trade-bar>
      <ng-template #operationPuppet hbDynamicComponentHost></ng-template>
      <app-day-trade
        *ngIf="showDayTrades"
        [dayTradesItems]="dayTrades"
        [nextDate]="dayTradeNextDate"
      ></app-day-trade>
    </div>
  </section>

  <div class="wrapper-footer">
    <section>
      <hb-custom-footer></hb-custom-footer>
    </section>
  </div>
  <ng-container *ngIf="canUseChat">
    <!-- TODO: unused custom chats -->
    <!-- <ng-container *ngIf="isHelpChat">
      <hb-ujet-chat *ngIf="isUjetChat"></hb-ujet-chat>
      <app-chat-menu *ngIf="!isUjetChat"></app-chat-menu>
    </ng-container> -->
    <ng-container *ngIf="!isHelpChat">
      <hb-whatsapp-chat></hb-whatsapp-chat>
    </ng-container>
  </ng-container>
  <inactivity-detector></inactivity-detector>
  <hb-market-footer-bar></hb-market-footer-bar>
</div>
<hb-upgrade-modal
  *ngIf="isTradingUpgradeModalVisible"
  (upgradeModalActionEmitter)="handleUpgradeModal($event)"
></hb-upgrade-modal>
